<nz-layout>
  <nz-content><ng-container>
      <app-reusable-table title="Past Medication" [columns]="[
          'Onset Date & Time',
          'End Date & Time',
          'Product',
          'Package',
          'Unit',
          'Frequency',
          'Duration'
        ]" [rowFields]="[
          'onSetDateTime',
          'endDateTime',
          'productCombination',
          'packageCombination',
          'unitCombination',
          'frequencyCombination',
          'durationTreatmentCombination'
        ]" [data]="pastMedication" [isLoading]="isLoading" [deleteFun]="deleteFun" [openModalFun]="openModalFun"
        [revertStopFun]="revertStopFun" [expandComponent]="expandComp" [isPreview]="false" [isStopped]="true"
        [addPermissions]="['a-pmed']" [stopPermissions]="['s-med']" />
    </ng-container>
  </nz-content>
</nz-layout>